// extracted by mini-css-extract-plugin
export var actionButton = "_ic-0";
export var fileInput = "_ic-2";
export var paperclip = "_ic-1";